import http from '../http'

export default {
  // 代理商转账接口
  transferAgentGold(data: object) {
    return http.post('/web/AgentGold', data);
  },
  // 代理商创建充值订单
  createAgentRechargeOrder(data: object) {
    return http.post('/web/payment/createOrder', data);
  },
  // 代理商获取支付方式
  getAgentPayMethods(data: object) {
    return http.post('/web/payment/methods', data);
  },
  // 获取代理商转移金币记录
  getAgentTransferRecord(data: object) {
    return http.post('/web/UserExtendRecordList', data);
  },
  // 获取代理商列表
  getAgentList(data: object) {
    return http.post('/web/agent/list', data);
  },
}
